import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { ArrowRightOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useAuth as useOidcAuth } from 'react-oidc-context';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isLocalAuthBypassEnabled } from '../authConfig';
import {
  consumePostLoginRedirect,
  peekPostLoginRedirect,
  savePostLoginRedirect,
} from '../../utils/postLoginRedirect';
import loginHeroBg from '../../assets/login-hero-bg.png';
import './Login.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const auth = useOidcAuth();
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const from = location.state?.from;
    if (from?.pathname) {
      savePostLoginRedirect(`${from.pathname}${from.search || ''}${from.hash || ''}`);
    }
  }, [location.state]);

  const handleSSOLogin = () => {
    if (!process.env.REACT_APP_COGNITO_CLIENT_ID || !process.env.REACT_APP_COGNITO_AUTHORITY) {
      console.error('Cognito is not configured. Check frontend/.env.local and restart the dev server.');
      return;
    }
    setLoading(true);
    const returnTo = peekPostLoginRedirect() || '/dashboard';
    auth.signinRedirect({ state: returnTo });
  };

  const handleLocalDevLogin = () => {
    const clientId = process.env.REACT_APP_DEFAULT_CLIENT_ID || 'default';
    login({
      username: 'local-dev',
      token: 'local-dev-token',
      role: 'ADMIN',
      client_id: clientId,
    });
    navigate(consumePostLoginRedirect('/dashboard'), { replace: true });
  };

  return (
    <div className="login-page">
      <div
        className="login-page__photo"
        style={{ backgroundImage: `url(${loginHeroBg})` }}
        aria-hidden
      />
      <div className="login-page__photo-scrim" aria-hidden />
      <div className="login-page__light" aria-hidden />
      <div className="login-page__noise" aria-hidden />

      <main className="login-page__main">
        <header className="login-page__brand">
          <img
            src="/Logo/LOGO 180X180.svg"
            alt="ClairAI"
            className="login-page__brand-logo"
          />
          <p className="login-page__brand-subtitle">
            Enterprise observability and intelligent pipeline monitoring
          </p>
        </header>

        <div className="login-page__card-wrap">
          <div className="login-page__card">
            <h2 className="login-page__heading">Welcome back</h2>
            <p className="login-page__description">
              Sign in with your organization account to continue to your workspace.
            </p>
            <Button
              type="primary"
              size="large"
              block
              loading={loading}
              icon={<ArrowRightOutlined />}
              iconPosition="end"
              onClick={handleSSOLogin}
              className="login-page__signin-btn"
            >
              Continue with SSO
            </Button>
            {isLocalAuthBypassEnabled && (
              <Button
                type="default"
                size="large"
                block
                onClick={handleLocalDevLogin}
                className="login-page__signin-btn"
                style={{ marginTop: 12 }}
              >
                Continue as local dev (no SSO)
              </Button>
            )}
            <div className="login-page__card-trust">
              <SafetyCertificateOutlined className="login-page__trust-icon" aria-hidden />
              <span>Encrypted session · Your identity provider handles authentication</span>
            </div>
          </div>
        </div>

        <p className="login-page__footer">© 2026 ClairAI · All rights reserved</p>
      </main>
    </div>
  );
};

export default Login;
